const messages = {
  'page.create-org.title': 'Create organisation & charity',
  'page.create-org.tabs.organisation.label': 'Organisation',
  'page.create-org.tabs.charity.label': 'Charity',

  'page.create-org.section.basic': 'Details',
  'page.create-org.section.logo': 'Logo',
  'page.create-org.section.address': 'Address',

  'page.create-org.input.name.label': 'Name ({type})',
  'page.create-org.input.name.placeholder': 'OnHand',

  'page.create-org.input.hubspot-id.label': 'HubSpot ID',
  'page.create-org.input.hubspot-id.placeholder': '12345678',

  'page.create-org.input.website.label': 'Organisation website',
  'page.create-org.input.website.placeholder': 'https://beonhand.co.uk',
  'page.create-org.input.website.error': 'Invalid website URL',

  'page.create-org.input.team-size.label': 'Team size',
  'page.create-org.input.team-size.placeholder': 'Select team size',

  'page.create-org.input.contact-name.label': 'Contact name',
  'page.create-org.input.contact-name.placeholder': 'Jane Smith',

  'page.create-org.input.email.label': 'Email',
  'page.create-org.input.email.placeholder': 'contact@beonhand.co.uk',
  'page.create-org.input.email.error': 'Invalid email address',

  'page.create-org.input.phone-number.label': 'Phone number',
  'page.create-org.input.phone-number.placeholder': '0123 456 7890',

  'page.create-org.input.email-domains.label': 'Email domains',
  'page.create-org.input.email-domains.placeholder': 'e.g. beonhand.co.uk',
  'page.create-org.input.email-domains.error': 'Invalid domain',

  'page.create-org.input.street.label': 'Address line 1',
  'page.create-org.input.street.placeholder': '123 Main Street',

  'page.create-org.input.sub-street.label': 'Address line 2',
  'page.create-org.input.sub-street.placeholder': 'Suite 4B',

  'page.create-org.input.town.label': 'Town',
  'page.create-org.input.town.placeholder': 'London',

  'page.create-org.input.postcode.label': 'Postcode',
  'page.create-org.input.postcode.placeholder': 'SW1A 1AA',

  'page.create-org.input.region.label': 'Region',
  'page.create-org.input.region.placeholder': 'Greater London',
  'page.create-org.input.region.select-placeholder': 'Select a country',

  'page.create-org.logo.upload-info': 'Any image will be fitted into a square',
  'page.create-org.logo.upload-link': 'or click to upload',
  'page.create-org.logo.upload-new': 'Upload a different logo',
  'page.create-org.logo.complete': 'Logo uploaded successfully',
  'page.create-org.logo.error.ratio': 'Image must be square (1:1 ratio)',
  'page.create-org.logo.error.type': 'Only PNG, JPG, and JPEG files are accepted',

  'page.create-org.beta.description':
    'This feature is in beta. Please report any issues to the engineering team.',

  'page.create-org.btn.submit': 'Create {type}',
  'page.create-org.btn.loading': 'Creating...',
}

const createOrganisationNotifications = {
  'notifications.organisation.create.success.title': 'Organisation successfully created',
  'notifications.organisation.create.success.description':
    'The organisation {organisation} has been successfully created.',
  'notifications.organisation.create.failure.title': 'Organisation not created!',
  'notifications.organisation.create.failure.description':
    'There has been a problem creating this organisation. Please try again',
}

const createCharityNotifications = {
  'notifications.charity.create.success.title': 'Charity successfully created',
  'notifications.charity.create.success.description':
    'The charity {charity} has been successfully created.',
  'notifications.charity.create.failure.title': 'Charity not created!',
  'notifications.charity.create.failure.description':
    'There has been a problem creating this charity. Please try again',
}

export default {
  ...messages,
  ...createOrganisationNotifications,
  ...createCharityNotifications,
}
